import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import ErrorBoundary from 'canopy-react-error-boundary'

import VirusModal from './virus-modal.component'

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: ErrorBoundary({ featureName: 'Docs Virus Scanning' })(VirusModal)
})

const featureToggles = [];

const bootstrap = [
  () => {
    if (!!featureToggles.length) {
      return SystemJS.import('feature-toggles!sofe').then(ft => ft.fetchFeatureToggles(...featureToggles))
    } else {
      return Promise.resolve();
    }
  },
  reactLifecycles.bootstrap,
]

export const VirusModalParcel = {
  ...reactLifecycles,
  bootstrap,
}
